
import { Button, Checkbox, DatePicker, Form } from "antd";
import React, { useContext } from "react";
import { ToastContext } from "../../context/ToastContext";
import InfoBox from "../InfoBox";

interface BillingDataFormPayload {
  dates: Date[];
}

interface DownloadBillingDataFormProps {
  form: any;
  onFinish?: () => void;
}

const DownloadBillingDataForm: React.FC<DownloadBillingDataFormProps> = (props) => {
  const { form, onFinish } = props;
  const { loadMessage, loading } = useContext(ToastContext);
  return (
    <>
      <Form<BillingDataFormPayload>
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ }}
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="dates"
          label="Start and end date"
          rules={[
            {
              required: true,
              message: "Please input ${label}!",
            },
          ]}
        >
          <DatePicker.RangePicker />
        </Form.Item>
        { onFinish && (
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button loading={loading} type="primary" htmlType="submit">
              Download
            </Button>
          </Form.Item>
        )}
      </Form>
    </>
  );
};

export default DownloadBillingDataForm;